import { createFileRoute } from '@tanstack/react-router';
import TenantDocumentRequests from '@/modules/document-requests/pages/tenant-document-requests';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/document-requests/',
)({
  head: () => ({
    meta: [{ title: 'Solicitações de Documentos' }],
  }),
  component: TenantDocumentRequests,
});
